import React, { useEffect } from "react";
import { Typography, Paper, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import Technologies from "../components/technologies";

const BigData = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <Paper
        elevation={0}
        sx={{
          backgroundImage: 'url("/assets/BigData/Banner.png")',
          backgroundPosition: "center",
          backgroundSize: "cover",
          maxWidth: "100%",
          height: "480px",
          display: "flex",
          overflowX: "hidden",
          backgroundColor: "transparent",
          // background: "radial-gradient(89.93% 185.59% at 93.34% 88.71%, #47002F 17.77%, #000000 76.74%)"
        }}
      >
        <Paper
          disableGutters
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: "lg",
            margin: "0 0 0 10%",
            backgroundColor: "transparent",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "18px", sm: "24px", md: "28px" }, // Font size for different screen sizes
              color: "#FFFFFF",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "flex-start",
              paddingBottom: "2%",
            }}
          >
            Experience Data as a Differentiator with our
          </Typography>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "36px", sm: "48px", md: "60px" }, // Font size for different screen sizes
              color: "#F005A2",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              paddingBottom: "2%",
            }}
          >
            Big Data Solutions
          </Typography>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "18px", sm: "20px", md: "24px" }, // Font size for different screen sizes
              color: "#FFFFFF",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "flex-start",
              paddingBottom: "5%",
              padding: { xs: "10px", sm: "15px", md: "20px" },
              marginBottom: { xs: "20px" }, // Padding for different screen sizes
            }}
          >
            Data-driven Insights for Business Growth
          </Typography>
          <Link
            to="/clientForm"
            style={{
              display: "flex",
              width: "150.84px",
              height: "52.23px",
              backgroundColor: "#F005A2",
              borderRadius: "45.25px",
              opacity: "100%",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 2% 0 2%",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <div
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "18px",
                letterSpacing: "8%",
                fontWeight: "700",
              }}
            >
              Contact Us
            </div>
            <div
              className="submitBtn__Arrow"
              style={{
                width: "32.84px",
                height: "32.23px",
                backgroundColor: "#FFFFFF",
                borderRadius: "45.25px",
                opacity: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "7%",
              }}
            >
              <ArrowForwardIcon></ArrowForwardIcon>
            </div>
          </Link>
        </Paper>
      </Paper>

      <Box
        sx={{
          maxWidth: "100%",
          height: "auto",
          marginTop: { xs: "10%", md: "8%" },
          paddingX: { xs: "3%", md: "0" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: 800,
            fontSize: { xs: "24px", sm: "32px", md: "40px" },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "5%", md: "4%" },
            textAlign: "center",
          }}
        >
          Tecloq's Big Data Solutions
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", sm: "16px", md: "20px" },
            color: "#000000",
            textAlign: "center",
            paddingBottom: { xs: "8%", md: "2%" },
            marginX: { xs: "5%", sm: "8%", md: "11%" },
          }}
        >
          In today's data-driven world, Big Data engineering plays a pivotal
          role in unleashing the true potential of raw data. Harnessing the
          immense potential of Big Data is a game-changer for businesses in the
          digital age. Tecloq specializes in delivering cutting-edge Data.
        </Typography>
      </Box>

      <Box>
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: 800,
            fontSize: { xs: "24px", sm: "32px", md: "40px" },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "center" },
            textAlign: "center",
            paddingBottom: { xs: "3%", md: "5%" },
            paddingX: { xs: "5%", md: "0" },
          }}
        >
          Our Big Data Engineering Services
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: { xs: "5%", md: "3%" }, // Increased gap for smaller screens
          }}
        >
          {[
            {
              img: "/assets/BigData/DW.png",
              title: "Data Warehouse",
              description:
                "Leveraging cutting-edge big data platforms and cloud data engineering techniques, we build robust data warehousing solutions tailored to your specific requirements. Say goodbye to data silos and gain a holistic view of your business.",
            },
            {
              img: "/assets/BigData/DP.png",
              title: "Data Pipelines",
              description:
                "Tecloq's data engineers are skilled in designing and implementing high-performance data pipelines. Whether you need real-time data streaming or batch processing, we have the expertise to optimize your data flow and enable smooth data integration.",
            },
            {
              img: "/assets/BigData/DV.png",
              title: "Data Visualization",
              description:
                "Our Data Visualization services bridge the gap between raw data and meaningful information. We use advanced data visualization tools and techniques to create intuitive dashboards and reports. Empowering you to make informed decisions quickly and effectively.",
            },
          ].map((service, index) => (
            <Paper
              key={index}
              elevation={3}
              sx={{
                borderRadius: "3%",
                textAlign: "center",
                border: "0.5px solid #FFC3EA",
                alignContent: "center",
                boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
                display: "flex",
                flexDirection: "column",
                background:
                  "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
                width: { xs: "100%", sm: "320px", md: "370px" }, // Responsive width
                height: { xs: "auto", sm: "450px", md: "500px" }, // Responsive height
                padding: { xs: "2%", sm: "4%", md: "3%" },
                margin: { xs: "4%" },
              }}
            >
              <img
                src={service.img}
                alt={service.title}
                style={{
                  width: "30%",
                  height: "auto",
                  margin: "0 auto",
                  paddingTop: "10%", // Reduced for better mobile fit
                }}
              />
              <Typography
                sx={{
                  fontFamily: "Orbitron",
                  lineHeight: "120%",
                  fontSize: { xs: "22px", sm: "24px", md: "28px" },
                  fontWeight: "700",
                  color: "#F005A2",
                  letterSpacing: "2%",
                  marginTop: "5%",
                }}
              >
                {service.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  lineHeight: "140%",
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  padding: { xs: "8%", sm: "10%", md: "10% 10% 3% 10%" },
                }}
              >
                {service.description}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "5%", md: "3%" }, // Increased margin for smaller screens
          paddingX: { xs: "5%", md: "0" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "28px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "3%", md: "1%" }, // Adjusted for mobile
          }}
        >
          The Process
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", sm: "18px", md: "20px" }, // Responsive font size
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            margin: { xs: "3% 5% 5% 5%", md: "1% 10% 2% 10%" }, // Adjusted margins for better fit
            lineHeight: "140%",
          }}
        >
          With Tecloq, your data journey is seamless and efficient. Our Big Data
          experts utilize data from across the business ecosystem, crafting a
          comprehensive approach that ensures your data delivers meaningful and
          impactful results. Choosing Tecloq as your Data Analytics Services
          partner means embracing a holistic approach to data-driven
          decision-making. We stand out for several reasons.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "100%",
          height: "auto",
          alignItems: "center",
        }}
      >
        <img
          src="/assets/BigData/ProcessGIF.gif"
          alt="tech"
          style={{ width: "75%", height: "auto", paddingTop: "3%" }}
        ></img>
      </Box>

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "5%", md: "3%" }, // Adjust margin for mobile
          paddingX: { xs: "5%", md: "0" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "28px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "3%", md: "1%" }, // Adjusted for mobile and desktop
          }}
        >
          The Tecloq Advantage
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", sm: "18px", md: "20px" }, // Responsive font size
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            margin: { xs: "3% 5% 5% 5%", md: "1% 10% 2% 10%" }, // Adjusted margins for different screens
            lineHeight: "140%",
          }}
        >
          Partnering with Tecloq gives you access to industry-leading data
          engineering consulting and solutions. Our team's in-depth knowledge
          and experience allow us to tackle complex data challenges and deliver
          solutions that drive tangible results for your business. Our Big Data
          analytics services enable accurate consolidation, management,
          protection, and understanding of your business-aligned data. Here's
          what sets us apart.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: { xs: "5%", md: "3%" },
          marginTop: { xs: "5%", md: "3%" },
        }}
      >
        {[
          {
            imgSrc: "/assets/BigData/image1.png",
            title: "Empowering Business Transformation",
            description:
              "Tecloq isn't just another tech-driven company. Our data engineering practice is dedicated to driving tangible outcomes, focusing on building robust data models that deliver lasting business value beyond defined use cases.",
          },
          {
            imgSrc: "/assets/BigData/image3.png",
            title: "Accelerated Insights Delivery",
            description:
              "With our cutting-edge suite of accelerators, Tecloq’s data engineering solutions slash time-to-value by an impressive 30% compared to traditional consulting and technology service firms. Get the insights you need faster and stay ahead in today's competitive landscape.",
          },
          {
            imgSrc: "/assets/BigData/image2.png",
            title: "Harnessing the Power of Open Source",
            description:
              "Embracing the potential of open-source technology, our data engineering team enables accurate real-time analysis of massive data volumes while simultaneously reducing data storage costs. Collaborate effortlessly across diverse fields and maximize efficiency with our open-source approach.",
          },
        ].map((card, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "3%",
              textAlign: "center",
              border: "0.5px solid #FFC3EA",
              alignContent: "center",
              boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
              display: "flex",
              flexDirection: "column",
              width: { xs: "90%", sm: "45%", md: "370px" },
              height: { xs: "auto", md: "700px" },
              padding: { xs: "5%", md: "0" },
              margin: { xs: "4%"}
            }}
          >
            <img
              src={card.imgSrc}
              alt={card.title}
              style={{
                width: "70%",
                height: "auto",
                margin: "0 auto",
                paddingTop: "10%",
              }}
            />
            <Typography
              sx={{
                fontFamily: "Orbitron",
                lineHeight: "120%",
                fontSize: { xs: "22px", md: "28px" },
                fontWeight: "700",
                color: "#F005A2",
                letterSpacing: "2%",
                paddingTop: "5%",
              }}
            >
              {card.title.split(" ").slice(0, 3).join(" ")} <br />
              {card.title.split(" ").slice(3).join(" ")}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: { xs: "14px", md: "18px" },
                lineHeight: "140%",
                padding: "5% 8%",
                textAlign: "center",
              }}
            >
              {card.description}
            </Typography>
          </Paper>
        ))}
      </Box>

      <Technologies />
    </Box>
  );
};

export default BigData;
